import React from 'react';

export const POLICY_VERSION = 'v1.0-2026-02';

// Reusable layout for the 3 policy pages — keeps copy + structure consistent
// and easy to refresh when legal counsel reviews the boilerplate.
export const PolicyLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-white">
    <header className="bg-navy text-white">
      <div className="container mx-auto px-4 sm:px-6 py-6 flex items-center justify-between">
        <a href="/" className="text-gold font-bold text-lg" data-testid="policy-back-home">ProcureOne Ultra</a>
        <nav className="text-xs space-x-4">
          <a href="/privacy-policy" className="hover:text-gold" data-testid="policy-nav-privacy">Privacy</a>
          <a href="/terms-and-conditions" className="hover:text-gold" data-testid="policy-nav-terms">Terms</a>
          <a href="/data-protection-policy" className="hover:text-gold" data-testid="policy-nav-dpdp">DPDP</a>
        </nav>
      </div>
    </header>
    <main className="container mx-auto px-4 sm:px-6 py-10 max-w-3xl">
      <h1 className="text-3xl sm:text-4xl font-bold text-navy tracking-tight" data-testid="policy-page-title">{title}</h1>
      <div className="text-xs text-muted-foreground mt-1">
        Effective Date: <strong>{lastUpdated}</strong> · Version <strong>{POLICY_VERSION}</strong>
      </div>
      <div className="prose prose-sm max-w-none mt-6 text-navy/90 leading-relaxed">{children}</div>
      <hr className="my-10 border-border" />
      <p className="text-[11px] text-muted-foreground">
        This is launch-ready boilerplate generated for review by qualified legal counsel.
        For any clarification, write to <a href="mailto:sawant.ds@gmail.com" className="underline">sawant.ds@gmail.com</a>.
      </p>
    </main>
    <PolicyFooter />
  </div>
);

export const PolicyFooter = () => (
  <footer className="border-t border-border bg-muted/30 mt-10">
    <div className="container mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] text-muted-foreground">
      <span>© Plus Ultra Innovation · Thane, Maharashtra, India · GSTIN 27EYMPS1491H1ZT</span>
      <span className="space-x-3">
        <a href="/privacy-policy" className="hover:text-navy" data-testid="footer-privacy-link">Privacy Policy</a>
        <a href="/terms-and-conditions" className="hover:text-navy" data-testid="footer-terms-link">Terms & Conditions</a>
        <a href="/data-protection-policy" className="hover:text-navy" data-testid="footer-dpdp-link">Data Protection</a>
      </span>
    </div>
  </footer>
);

// Inline component used on Register + Pricing checkout
export const ConsentCheckbox = ({ checked, onChange, testid = 'consent-checkbox' }) => (
  <label className="flex items-start gap-2 text-xs text-navy cursor-pointer select-none" data-testid={`${testid}-label`}>
    <input
      type="checkbox"
      checked={!!checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 h-3.5 w-3.5"
      data-testid={testid}
    />
    <span>
      I have read and agree to the{' '}
      <a href="/terms-and-conditions" target="_blank" rel="noreferrer" className="underline text-orange" data-testid={`${testid}-terms-link`}>Terms &amp; Conditions</a>,{' '}
      <a href="/privacy-policy" target="_blank" rel="noreferrer" className="underline text-orange" data-testid={`${testid}-privacy-link`}>Privacy Policy</a>{' '}
      and{' '}
      <a href="/data-protection-policy" target="_blank" rel="noreferrer" className="underline text-orange" data-testid={`${testid}-dpdp-link`}>Data Protection Policy</a>.
    </span>
  </label>
);
